import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import ArticleCard from '@/components/base/ArticleCard';
import HeroSection from './components/HeroSection';
import FeaturedCategories from './components/FeaturedCategories';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import { articles } from '@/mocks/articles';
import { siteConfig } from '@/mocks/siteConfig';

const featuredArticles = articles.slice(0, 6);

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: siteConfig.name,
      url: siteConfig.url,
      description: siteConfig.description,
      foundingDate: String(siteConfig.foundingYear),
      contactPoint: {
        '@type': 'ContactPoint',
        email: siteConfig.email,
        contactType: 'customer service',
      },
    },
    {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
      description: siteConfig.description,
      potentialAction: {
        '@type': 'SearchAction',
        'target': `${siteConfig.url}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: `${siteConfig.name} - 首页`,
      url: siteConfig.url,
      description: siteConfig.description,
      isPartOf: {
        '@type': 'WebSite',
        name: siteConfig.name,
        url: siteConfig.url,
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '福利视频导是什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '福利视频导是一个视频内容聚合导航平台，我们通过智能推荐算法与人工精选相结合，为用户提供全网优质视频资源的精准分类导航服务。',
          },
        },
        {
          '@type': 'Question',
          name: '福利视频导是否收费？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '福利视频导完全免费！所有分类导航、文章阅读、内容推荐功能均不收取任何费用。',
          },
        },
        {
          '@type': 'Question',
          name: '如何使用福利视频导的分类导航？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '在首页点击任意分类卡片，或在顶部导航栏选择视频分类，即可进入分类浏览页面。点击文章卡片可查看详细内容。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title={`${siteConfig.name} - ${siteConfig.tagline} | ${siteConfig.keywords.split(',')[0]}`}
        description={siteConfig.description}
        keywords={siteConfig.keywords}
        canonicalUrl={siteConfig.url}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturedCategories />
        <StatsSection />

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
                  精选推荐
                </h2>
                <p className="text-sm text-secondary-500">
                  编辑精选的优质视频内容文章
                </p>
              </div>
              <Link
                to="/category"
                className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.slug} {...article} />
              ))}
            </div>
            <div className="mt-8 text-center sm:hidden">
              <Link
                to="/category"
                className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
              >
                查看全部文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <FAQSection />

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-accent-500">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">
              加入福利视频导，发现更多精彩
            </h2>
            <p className="text-sm text-background-50/80 mb-8 max-w-lg mx-auto">
              每天更新精选视频内容，涵盖娱乐、学习、生活等八大领域，总有一款适合你
            </p>
            <Link
              to="/category"
              className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-accent-700 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
            >
              <i className="ri-compass-line"></i>
              开始探索
            </Link>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}